import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cde63de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page-block-header-wrap" }
const _hoisted_2 = { class: "home-page-block-header" }
const _hoisted_3 = { class: "home-page-block-header-title-wrap" }
const _hoisted_4 = { class: "home-page-block-header-sub-title" }
const _hoisted_5 = { class: "home-page-block-header-text" }
const _hoisted_6 = { class: "home-page-block-header-button-wrap" }

import {BlockPreviewData, WrapTitle} from "@/entities";
import {simplify_payments, UiButton, useLocalizationStore} from "@/shared";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'home-page-block-header',
  setup(__props) {

const router = useRouter();

const {translate} = useLocalizationStore();

const onClick = () => {
  router.push({name: "products-services"});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BlockPreviewData), {
        "body-title": _unref(translate)('experience_future_payments'),
        image: _unref(simplify_payments),
        class: "left big"
      }, {
        "header-title": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(WrapTitle), {
              text: _unref(translate)('simplify_payments'),
              class: "home-page-block-header-title",
              weight: "800"
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("payments_solutions")), 1)
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_unref(translate)("home_page_first_text")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(translate)("home_page_second_text")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(UiButton), {
              class: "home-page-block-header-button",
              color: "#71B92F",
              height: "45",
              onClick: onClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("explore_our_products")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["body-title", "image"])
    ])
  ]))
}
}

})